module.exports = __webpack_public_path__ + "img/ioniq9-26.80e16885.png";